import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <Link to="/" className="action-button">Home</Link>
      <h1>Privacy Policy</h1>
      <p>
        Practice Capsule built the Practice Capsule app as
        a Free app. This SERVICE is provided by
        Practice Capsule at no cost and is intended for use as
        is.
      </p>
      <p>
        This page is used to inform visitors regarding our
        policies with the collection, use, and disclosure of Personal
        Information if anyone decided to use our Service.
      </p>
      <p>
        If you choose to use our Service, then you agree to
        the collection and use of information in relation to this
        policy. The Personal Information that we collect is
        used for providing and improving the Service. We will not use or share your information with
        anyone except as described in this Privacy Policy.
      </p>
      <p>
        The terms used in this Privacy Policy have the same meanings
        as in our Terms and Conditions, which are accessible at
        Practice Capsule unless otherwise defined in this Privacy Policy.
      </p>

      <h3>Information Collection and Use</h3>

      <p>
        For a better experience, while using our Service, we
        may require you to provide us with certain personally
        identifiable information, including but not limited to email, name. The information that
        we request will be retained by us and used as described in this privacy policy.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
